import * as React from 'react';
import type { FlowEventContextValue } from './types';

const PageEventContext = React.createContext<FlowEventContextValue<any>>({
  trackEvent: () => false,
});
export default PageEventContext;
